import { render, staticRenderFns } from "./BountyPayoutIcon.vue?vue&type=template&id=6408f965&scoped=true"
import script from "./BountyPayoutIcon.vue?vue&type=script&lang=js"
export * from "./BountyPayoutIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6408f965",
  null
  
)

export default component.exports